import PropTypes from 'prop-types'

export const SELECT_ACTIONS = {
  SELECT_OPTION: 'select-option', // onChange
  INPUT_CHANGE: 'input-change', // onInputChange
  // INPUT_BLUR: 'input-blur', // onInputChange
  // MENU_CLOSE: 'menu-close', // onInputChange
  // SET_VALUE: "set-value", // onInputChange - doesn't actually have any value
}

export const SelectProps = {
  label: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
      label: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
    })
  ).isRequired,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onInputChange: PropTypes.func,
  menuPlacement: PropTypes.oneOf(['auto', 'top', 'bottom']),
  isSearchable: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

export const SelectDefaultProps = {
  options: [],
  onChange: () => {},
  onInputChange: () => {},
  placeholder: '',
  menuPlacement: 'auto',
  isSearchable: true,
  isDisabled: false,
  label: '',
  description: '',
}
